import CollapseTooltips from './Collapse'


export default CollapseTooltips